// extracted by mini-css-extract-plugin
export default {"avatar__container":"Avatar_avatar__container__Qglx+","avatar":"Avatar_avatar__TjAw6"};